import assertString from './util/assertString';

export default function equals(str, comparison) {
  assertString(str);
  return str === comparison;
}
